export const Colors = {
  green: "#0A4D43",
  lightGreyBackground: "#f3f3f3",
  grey: "#858383",
  gold: "#D4AF60",
  darkBrown: "#954435",
  background: "#F2EBE1",
  lightGreen: "#175f50",
  greenBg: "#dbede6",
  yellow: "#D4AF60",
  white: "#fff",
  black: "#000",
  success: "#4da381",
  lightGoldenWithOpacity: "#a6b7ad",
  pink: '#CFABA4',
};
